import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import AdminLogin from '../components/admin/AdminLogin';
import AdminPanel from '../components/admin/AdminPanel';
import { api, getToken, clearToken } from '../services/api';

const AdminPage = () => {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Inject noindex meta tags so search engines don't index this page
    document.title = 'Restricted';
    const metas = [
      { name: 'robots', content: 'noindex, nofollow, noarchive, nosnippet' },
      { name: 'googlebot', content: 'noindex, nofollow' }
    ];
    const added = metas.map(m => {
      const el = document.createElement('meta');
      el.name = m.name;
      el.content = m.content;
      document.head.appendChild(el);
      return el;
    });
    return () => added.forEach(el => el.remove());
  }, []);

  useEffect(() => {
    const t = getToken();
    if (t) {
      // quick verify
      api.adminGetMenu().then(() => { setAuthed(true); }).catch(() => {
        clearToken();
        setAuthed(false);
      }).finally(() => setChecking(false));
    } else {
      setChecking(false);
    }

    const onExpired = () => {
      clearToken();
      setAuthed(false);
    };
    window.addEventListener('la_maria_auth_expired', onExpired);
    return () => window.removeEventListener('la_maria_auth_expired', onExpired);
  }, []);

  const handleLogin = async (password) => {
    try {
      await api.login(password);
      setAuthed(true);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleLogout = () => {
    clearToken();
    setAuthed(false);
  };

  return (
    <div className="min-h-screen bg-[#FAF6F0]">
      <Header />
      <main className="pt-24 pb-16 px-6">
        {checking ? (
          <p className="text-center text-[#6B6257]">…</p>
        ) : authed ? (
          <AdminPanel onLogout={handleLogout} />
        ) : (
          <AdminLogin onLogin={handleLogin} />
        )}
      </main>
    </div>
  );
};

export default AdminPage;
